import { render, staticRenderFns } from "./Adoptions.vue?vue&type=template&id=608def30&"
import script from "./Adoptions.vue?vue&type=script&lang=js&"
export * from "./Adoptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports